import sidebarContent from './sidebarContent'

export default [...sidebarContent]
